/* ════════════════════════════════════════════
   Nude Project Theme — Animations JavaScript
   ════════════════════════════════════════════ */

(function() {
  'use strict';

  // Respect prefers-reduced-motion
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // ─── SCROLL REVEAL (Intersection Observer) ───
  var revealElements = document.querySelectorAll('.js-fade-up, .js-fade-in, .js-slide-left, .js-slide-right, .js-scale-in');

  if ('IntersectionObserver' in window && revealElements.length > 0) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    revealElements.forEach(function(el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show all
    revealElements.forEach(function(el) {
      el.classList.add('is-visible');
    });
  }

  // ─── IMAGE REVEAL (sweep effect) ───
  document.querySelectorAll('.js-image-reveal').forEach(function(img) {
    img.addEventListener('load', function() {
      img.style.animation = 'sweepReveal 0.8s ease forwards';
    });
    if (img.complete) {
      img.style.animation = 'sweepReveal 0.8s ease forwards';
    }
  });

  // ─── PARALLAX (subtle, hero only) ───
  var heroImage = document.querySelector('.homepage-hero__media');
  if (heroImage) {
    var parallaxAmount = 30;
    window.addEventListener('scroll', function() {
      requestAnimationFrame(function() {
        var scrolled = window.pageYOffset;
        var heroRect = heroImage.getBoundingClientRect();
        if (heroRect.bottom > 0) {
          var offset = scrolled * 0.15;
          if (offset > parallaxAmount) offset = parallaxAmount;
          heroImage.style.transform = 'translateY(' + offset + 'px)';
        }
      });
    }, { passive: true });
  }

  // ─── CUSTOM CURSOR REMOVED ───


  // ─── PAGE TRANSITION (fade out on navigate) ───
  document.querySelectorAll('a[href]').forEach(function(link) {
    // Skip external, anchor, and special links
    if (link.hostname !== window.location.hostname) return;
    if (link.getAttribute('href').charAt(0) === '#') return;
    if (link.getAttribute('target') === '_blank') return;
    if (link.closest('[data-no-transition]')) return;
    if (link.hasAttribute('data-subnav-link') || 
        link.hasAttribute('data-clear-filters') || 
        link.classList.contains('active-filter-tag') || 
        link.classList.contains('product-card__swatch') ||
        link.closest('[data-filter-toggle]') ||
        link.closest('[data-filter-close]')) return;

    link.addEventListener('click', function(e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      var href = link.getAttribute('href');
      e.preventDefault();
      document.body.classList.add('page-exit');
      setTimeout(function() {
        window.location.href = href;
      }, 300);
    });
  });

})();
